import { Controller } from "stimulus";

export default class extends Controller
{
    static targets = ["editMode"]
    connect()
    {
        if(window.App.EDIT_MODE) this.editModeTarget.classList.add("active");
        
        this.editModeTarget.addEventListener("click", e =>
        {
            if(this.editModeTarget.classList.contains("active"))
            {
                this.editModeTarget.classList.remove("active");
                let event = new CustomEvent("disable-edit-mode");
                let res = window.dispatchEvent(event);
            }
            else
            {
                this.editModeTarget.classList.add("active");
                let event = new CustomEvent("enable-edit-mode");
                let res = window.dispatchEvent(event);
            }
        })
    }

    disconnect()
    {
        window.App.EDIT_MODE = false;
    }
}